export enum EmailDetailStatus {
    CREATED = 1, // created / not sent / no reply
    SENT = 2, // sent/ no reply or unsubscribed
    NOT_SENT = 3, // not sent / error / no reply
    OPENED = 4, // sent / opened / no reply or unsubscribed
    COMPLETED = 6, // sent / opened / reply or unsubscribed
}

export enum EmailFilterStatus {
    ALL = 1,
    READY = 2,
    NOT_READY = 3,
    SENT = 4,
    NOT_SENT = 5,
    UNSUBS = 6,
    OPENED = 7,
}

export const EMAIL_FILTER_STATUS_LABELS: { [key: string]: string } = {
    [EmailFilterStatus.ALL]: 'Все',
    [EmailFilterStatus.READY]: 'Ответ получен',
    [EmailFilterStatus.NOT_READY]: 'Ответ не получен',
    [EmailFilterStatus.SENT]: 'Отправлено',
    [EmailFilterStatus.NOT_SENT]: 'Не отправлено',
    [EmailFilterStatus.UNSUBS]: 'Отписались от рассылки',
    [EmailFilterStatus.OPENED]: 'Опрос открыт',
};

export interface EmailDetail {
    recipient: string;
    startDatetime: string;
    status: EmailDetailStatus;
    responseDatetime: string;
    unsubscribed: boolean;
}

export const initialEmailDetail: Readonly<EmailDetail> = {
    recipient: null,
    startDatetime: null,
    status: null,
    responseDatetime: null,
    unsubscribed: false,
};
